export default "__VITE_ASSET__BZmeowGN__"